<script setup>
/**
 * Aviso de limite de conversas fixadas.
 *
 * `Conversations::PinConversationService::LIMIT` e 3: a tentativa de fixar a
 * quarta volta em 422 e cai aqui. Antes o aviso era um toast, que passava
 * despercebido no canto da tela.
 *
 * O <Teleport to="body"> e obrigatorio: a coluna da lista tem overflow, e sem
 * o teleport o backdrop nasce dentro dela e some. Mesmo motivo do
 * AclConversationDeleteModal, de onde este layout foi copiado.
 */
const props = defineProps({
  open: { type: Boolean, default: false },
});
const emit = defineEmits(['close']);

const TEXT = {
  message: 'Você pode fixar até 3 conversas.',
  confirm: 'OK',
};

function close() {
  emit('close');
}
</script>

<template>
  <Teleport to="body">
    <Transition name="pin-limit-modal">
      <div
        v-if="props.open"
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-[rgba(15,23,42,0.55)] p-4"
        tabindex="-1"
        @click.self="close"
        @keydown.esc.stop.prevent="close"
      >
        <div
          class="pin-limit-modal relative max-h-full overflow-auto shadow-md modal-container rtl:text-right skip-context-menu"
          role="alertdialog"
          aria-modal="true"
          aria-describedby="pin-limit-modal-message"
        >
          <div class="pin-limit-modal__content">
            <p id="pin-limit-modal-message" class="pin-limit-modal__message">
              {{ TEXT.message }}
            </p>

            <div class="pin-limit-modal__actions">
              <button
                type="button"
                class="pin-limit-modal__confirm"
                autofocus
                @click="close"
              >
                {{ TEXT.confirm }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.pin-limit-modal {
  z-index: 10000;
  width: min(32rem, calc(100vw - 2rem));
  max-height: calc(100vh - 2rem);
  border: 0;
  border-radius: 1.5rem;
  background: #ffffff;
  padding: 2.5rem 2.5rem 2rem;
}

.pin-limit-modal__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pin-limit-modal__message {
  margin: 0;
  text-align: left;
  color: #111827;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.5;
}

.pin-limit-modal__actions {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-top: 2rem;
}

.pin-limit-modal__confirm {
  display: inline-flex;
  min-width: 7rem;
  min-height: 3rem;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9999px;
  background: #278c68;
  padding: 0.75rem 1.75rem;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.25;
  transition: background-color 0.15s ease;
}

.pin-limit-modal__confirm:hover {
  background: #19704f;
}

.pin-limit-modal-enter-active,
.pin-limit-modal-leave-active {
  transition: opacity 0.2s ease;
}

.pin-limit-modal-enter-from,
.pin-limit-modal-leave-to {
  opacity: 0;
}

:global(.dark) .pin-limit-modal {
  background: #111315;
}

:global(.dark) .pin-limit-modal__message {
  color: #f9fafb;
}

@media (max-width: 640px) {
  .pin-limit-modal {
    width: min(32rem, calc(100vw - 1rem));
    padding: 2rem 1.25rem 1.5rem;
  }

  .pin-limit-modal__confirm {
    width: 100%;
  }
}
</style>
